import { hasRepairedReport, mapReportBlocks, textRanges } from './report-blocks'

function restoreTable(raw) {
  const pipes = []
  for (const [start, end] of textRanges(raw)) {
    for (let index = start; index < end; index++) {
      if (raw[index] === '|')
        pipes.push(index)
    }
  }
  const adjacent = (left, right) => /^[ \t]*$/.test(raw.slice(left + 1, right))
  const cells = (start, end) => {
    const values = []
    for (let index = start; index < end; index++)
      values.push(raw.slice(pipes[index] + 1, pipes[index + 1]).trim())
    return values
  }

  for (let headerStart = 0; headerStart < pipes.length; headerStart++) {
    const start = pipes[headerStart]
    if (start > 0 && !/\s/.test(raw[start - 1]))
      continue
    let headerEnd = headerStart + 1
    while (headerEnd - headerStart <= 24 && headerEnd + 1 < pipes.length && !adjacent(pipes[headerEnd], pipes[headerEnd + 1]))
      headerEnd++
    const columns = headerEnd - headerStart
    if (columns < 2 || columns > 24 || headerEnd + 1 >= pipes.length)
      continue
    const separatorStart = headerEnd + 1
    const separatorEnd = separatorStart + columns
    if (separatorEnd >= pipes.length)
      continue
    const header = cells(headerStart, headerEnd)
    const separators = cells(separatorStart, separatorEnd)
    if (header.some(cell => !cell) || !separators.every(cell => /^:?-{3,}:?$/.test(cell)))
      continue

    const rows = [raw.slice(start, pipes[headerEnd] + 1), raw.slice(pipes[separatorStart], pipes[separatorEnd] + 1)]
    let rowEnd = separatorEnd
    let valid = true
    while (rowEnd + 1 < pipes.length && adjacent(pipes[rowEnd], pipes[rowEnd + 1])) {
      const rowStart = rowEnd + 1
      const end = rowStart + columns
      if (end >= pipes.length || cells(rowStart, end).some(cell => !cell)) {
        valid = false
        break
      }
      rows.push(raw.slice(pipes[rowStart], pipes[end] + 1))
      rowEnd = end
    }
    // 不一致的列数或后续无法解释的竖线，不擅自截断表格。
    if (!valid || rows.length < 3 || rowEnd + 1 < pipes.length)
      continue
    const suffix = raw.slice(pipes[rowEnd] + 1)
    if (suffix && !/^\s/.test(suffix))
      continue
    const prefix = raw.slice(0, start).trimEnd()
    return `${prefix ? `${prefix}\n\n` : ''}${rows.join('\n')}${suffix.trim() ? `\n\n${suffix.trimStart()}` : suffix}`
  }
  return raw
}

export function repairPipeTableRows({ source, tokens, appliedKeys }) {
  if (!hasRepairedReport(appliedKeys))
    return source
  return mapReportBlocks(tokens, restoreTable)
}

export function validatePipeTableRows({ beforeTokens, afterTokens }) {
  const count = tokens => tokens.filter(token => token.type === 'table').length
  return count(afterTokens) > count(beforeTokens)
}
